import './styles/antd.less';
import { Auth0Provider } from '@auth0/auth0-react';
import { HelmetProvider } from 'react-helmet-async';
import Client from '@ynomia/client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {
  AccessRuleProvider,
  AssetManagerProvider,
  AssetProvider,
  AssetUpdateProvider,
  ClientCacheProvider,
  ConfigurationProvider,
  DeviceProvider,
  ReportProvider,
  DigitalTwinProvider,
  FileProvider,
  LayerProvider,
  LayoutProvider,
  PlanProvider,
  StatusUpdateProvider,
  PlannedTwinIDUpdateProvider,
  UserProvider,
  VisibilityFilterProvider,
} from './context';
import { auth0Cache } from './services';
import config from './config';

const composeProviders = (...Providers) => Child => props => (
  Providers.reduce((acc, Provider) => (
    <Provider>
      {acc}
    </Provider>
  ), <Child {...props} />)
);

const WrappedApp = composeProviders(
  // Frequent User interaction (Small data, Fast response)
  AssetManagerProvider,
  AssetUpdateProvider,
  StatusUpdateProvider,
  PlannedTwinIDUpdateProvider,
  DigitalTwinProvider,
  // Data (Big data, Fast load)
  AssetProvider,
  DeviceProvider,
  PlanProvider,
  ReportProvider,
  LayerProvider,
  UserProvider,
  FileProvider,
  AccessRuleProvider,
  VisibilityFilterProvider,
  // Constants (Doesn't change often)
  LayoutProvider,
  ConfigurationProvider,
  ClientCacheProvider,
)(App);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <Auth0Provider
      domain={config.host.auth}
      clientId={config.host.clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        /**
       * Do not change the Auth0 audience unless you know what you are doing.
       * @TODO Change the audience name to a proper name.
       */
        audience: 'http://localhost:3000/api',
        scope: Client.constants.DEFAULT_AUTH0_LOGIN_SCOPE,
      }}
      useRefreshTokens
      cache={auth0Cache}
    >
      <React.StrictMode>
        <WrappedApp />
      </React.StrictMode>
    </Auth0Provider>
  </HelmetProvider>,
);
